'use strict'

module.exports = () => {
  const scopesMap = {}
  return {
    setScope: ({componentId, itemId}, scope) => {
      scopesMap[componentId] = scopesMap[componentId] || {}
      scopesMap[componentId][itemId] = scope
    },
    getScope: ({componentId, itemId}) => {
      const componentScopes = scopesMap[componentId]
      return componentScopes && componentScopes[itemId]
    },
    removeScope: ({componentId, itemId}) => {
      const componentScopes = scopesMap[componentId]
      if (componentScopes) {
        componentScopes[itemId].dispose()
        componentScopes[itemId] = null
      }
    },
    getAll: () => {
      return Object.values(scopesMap)
        .reduce((acc, curr) => acc.concat(Object.values(curr)), [])
    }
  }
}



// WEBPACK FOOTER //
// ./dataset-controller/scopeStore.js